/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keen_Lean_Heron_SwimInputs */

const en_keen_lean_heron_swim = /** @type {(inputs: Keen_Lean_Heron_SwimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Success`)
};

const de_keen_lean_heron_swim = /** @type {(inputs: Keen_Lean_Heron_SwimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfolg`)
};

/**
* | output |
* | --- |
* | "Success" |
*
* @param {Keen_Lean_Heron_SwimInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const keen_lean_heron_swim = /** @type {((inputs?: Keen_Lean_Heron_SwimInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keen_Lean_Heron_SwimInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_keen_lean_heron_swim(inputs)
	return de_keen_lean_heron_swim(inputs)
});